import { QueryClientProvider, type QueryClient } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";

import { CookieBanner } from "../platform/consent/CookieBanner";
import { ThemeProvider } from "../platform/themes/ThemeProvider";
import { ProFrameProvider } from "../platform/ui-switch/frame";
import { proStaffFrame } from "./pro-staff";
import type { createAppRouter } from "./router";

export interface AppProps {
  queryClient: QueryClient;
  router: ReturnType<typeof createAppRouter>;
  /**
   * "test" turns off Mantine's transitions and portals, and its CSS variables: jsdom resolves
   * their 20 kB `:root` sheet on every computed style, which each name query reads per element
   * (spec editor-test-speed).
   */
  env?: "default" | "test";
}

export function App({ queryClient, router, env = "default" }: AppProps) {
  return (
    <ThemeProvider env={env}>
      <QueryClientProvider client={queryClient}>
        {/* The staff pages' frame in Pro and Simple (app/pro-staff.tsx). */}
        <ProFrameProvider frame={proStaffFrame}>
          <RouterProvider router={router} />
        </ProFrameProvider>
        {/* Live's cookie banner, beside the router as live's is, so it asks on every page. */}
        <CookieBanner />
      </QueryClientProvider>
    </ThemeProvider>
  );
}
